<!-- app-subdomain-creators\src\Components\CreatorMediaFolderSidebar.vue -->

<!-- src/Components/CreatorMediaFolderSidebar.vue -->
<template>
  <div class="w-56 bg-zinc-50 rounded-xl">
    <div class="px-4 py-3 flex items-center justify-between">
      <h3 class="text-xs font-semibold text-zinc-600 uppercase tracking-wide">
        Folders
      </h3>
      <button
        class="text-base text-blue-500 hover:text-[#2D8CFF]"
        @click="onCreateFolder"
      >
        + New
      </button>
    </div>

    <div class="p-2 space-y-1 text-sm">
      <button
        v-for="folder in orderedFolders"
        :key="folder.id"
        class="w-full flex items-center gap-2 px-3 py-1.5 rounded-lg text-left hover:bg-zinc-100"
        :class="{
          'bg-blue-50 text-[#2D8CFF]': folder.id === currentFolderId
        }"
        :style="{ paddingLeft: 8 + folder.depth * 12 + 'px' }"
        @click="$emit('select-folder', folder.id)"
      >
      <FolderIcon class="h-7 w-7 text-zinc-400"/>


        <span class="truncate">{{ folder.name }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import {
  FolderIcon
} from "@heroicons/vue/24/outline";

// import {
//   CheckCircleIcon,
//   PhotoIcon,
//   FilmIcon,
//   DocumentTextIcon,
//   ExclamationCircleIcon,
// } from "@heroicons/vue/24/solid";

const props = defineProps({
  folders: { type: Array, default: () => [] },
  currentFolderId: { type: [Number, null], default: null },
});

const emit = defineEmits(['select-folder', 'create-folder']);

const buildHierarchy = (folders) => {
  const byId = new Map();
  folders.forEach(f => {
    byId.set(f.id, { ...f, children: [] });
  });

  const roots = [];

  byId.forEach(folder => {
    if (folder.parent_id) {
      const parent = byId.get(folder.parent_id);
      if (parent) {
        parent.children.push(folder);
      } else {
        roots.push(folder);
      }
    } else {
      roots.push(folder);
    }
  });

  const list = [];
  const traverse = (node, depth) => {
    list.push({
      id: node.id,
      name: node.name,
      parent_id: node.parent_id,
      depth,
    });
    node.children
      .sort((a, b) => a.name.localeCompare(b.name))
      .forEach(child => traverse(child, depth + 1));
  };

  roots
    .sort((a, b) => a.name.localeCompare(b.name))
    .forEach(root => traverse(root, 0));

  return list;
};

const orderedFolders = computed(() => buildHierarchy(props.folders));

const onCreateFolder = () => {
  emit('create-folder');
};
</script>
